import React from 'react';
import { ASSESSMENT_STATUS } from '../lib/status';

/** Assessment (timeline moment) status pill — small. `style` overrides the defaults. */
export default function AssessmentStatusPill({ status, style }) {
  const m = ASSESSMENT_STATUS[status] || ASSESSMENT_STATUS.locked;
  return (
    <span style={{
      padding: '4px 10px', borderRadius: 'var(--radius-pill)', background: m.soft, color: m.fg,
      fontFamily: 'var(--font-sans)', fontWeight: 'var(--w-medium)', fontSize: 10,
      letterSpacing: 'var(--track-eyebrow)', textTransform: 'uppercase',
      lineHeight: 1.2, whiteSpace: 'nowrap', ...style,
    }}>{m.label}</span>
  );
}
